import React from 'react';
import { useRedirectToMessagesHook } from './useRedirectToMessagesHook';

const MessagingRedirect = (props) => {
  useRedirectToMessagesHook(props);
  return null;
};

export default MessagingRedirect;
